import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Slide-over reutilizable: overlay derecho con backdrop glassmorphism.
 * Cierre por tecla ESC, por click en el backdrop y por el botón ×.
 *
 * Estilo cyber-minimalist alineado con styles.scss y variables.scss.
 * Bloquea el scroll del body mientras está abierto.
 *
 * Uso:
 * <app-slide-over [open]="isOpen" [title]="'>_ TÍTULO'" (closed)="onClose()">
 * ... contenido ...
 * </app-slide-over>
 */
@Component({
  selector: 'app-slide-over',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slide-over.component.html',
  styleUrls: ['./slide-over.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlideOverComponent implements OnChanges, OnDestroy {
  @Input() open = false;
  @Input() title = '';
  @Input() width: number | string = 420; // Modificado para aceptar %
  /** Si se usa, debe apuntar a un id presente en el contenido. */
  @Input() ariaLabelledBy?: string;

  @Output() closed = new EventEmitter<void>();

  private previousBodyOverflow: string | null = null;

  // Getter dinámico para los estilos CSS
  get widthStyle(): string {
    return typeof this.width === 'number' ? `${this.width}px` : this.width;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      if (this.open) {
        this.lockBodyScroll();
      } else {
        this.unlockBodyScroll();
      }
    }
  }

  ngOnDestroy(): void {
    this.unlockBodyScroll();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open) this.requestClose();
  }

  requestClose(): void {
    this.closed.emit();
  }

  private lockBodyScroll(): void {
    if (this.previousBodyOverflow === null) {
      this.previousBodyOverflow = document.body.style.overflow;
    }
    document.body.style.overflow = 'hidden';
  }

  private unlockBodyScroll(): void {
    if (this.previousBodyOverflow !== null) {
      document.body.style.overflow = this.previousBodyOverflow;
      this.previousBodyOverflow = null;
    }
  }
}